export const appConfigs = {
  stripePublicKey: process.env.REACT_APP_STRIPE_PUBLIC_KEY || 'stripe key',
};
